module.exports = __webpack_public_path__ + "img/je_icon.12ab5c2.png";